import * as actions from './actions';
import * as userActions from '../user/actions';
import * as digestsSuggestionsAction from '../digestsSuggestions/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    limit: 9,
    offset: 0,
    hasMore: true,
    count: 0,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const digestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_DIGESTS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case actions.SET_DIGESTS_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case actions.SET_DIGESTS:
            const mappedList =
                Array.isArray(action.list) && action.list.length
                    ? action.list.map((item) => ({ ...item, importanceChanged: false }))
                    : [];
            const list = state.list ? state.list.concat(mappedList) : mappedList;
            return {
                ...state,
                list: list,
                offset: action.offset,
                hasMore: action.hasMore,
                count: action.count,
                isFetching: false,
                isLoaded: true,
            };

        case actions.CLEAN_DIGESTS:
            return initialState;

        case actions.RESET_DIGESTS_FETCHING:
            return {
                ...state,
                isFetching: false,
            };

        case digestsSuggestionsAction.CLEAN_DIGESTS_SUGGESTION_DATA:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 6+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 8+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/digests/reducer.js